export const PHONE_DISPLAY = "06 85902421";
export const PHONE_TEL = "tel:+390685902421";

export const HERO_IMG =
  "https://images.pexels.com/photos/6640207/pexels-photo-6640207.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const ELECTRIC_IMG =
  "https://static.prod-images.emergentagent.com/jobs/ddf10a0f-e765-4650-92c3-a0dd530370f8/images/f3e4cebf781eff67203d6623b70450a483d7db8044cb33ff00e120dd7c621f8d.jpeg";

export const LOCK_IMG =
  "https://images.unsplash.com/photo-1677951570313-b0750351c461?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const GATE_IMG =
  "https://images.pexels.com/photos/18143352/pexels-photo-18143352.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const SERVICES = [
  {
    id: "elettrico",
    name: "Pronto Intervento Elettrico",
    tag: "Elettrico",
    icon: "zap",
    img: ELECTRIC_IMG,
    alt: "Operatore al lavoro su un lampadario in un appartamento",
    eta: "20-30 min",
    bullets: [
      "Ricerca guasti con diagnosi strumentale",
      "Risoluzione guasti e ripristino immediato",
      "Sostituzione componenti difettosi",
    ],
  },
  {
    id: "serrature",
    name: "Serrature & Apertura Porte",
    tag: "Serrature",
    icon: "key",
    img: LOCK_IMG,
    alt: "Chiave inserita in una serratura",
    eta: "20-25 min",
    bullets: [
      "Sblocco porte in emergenza, zero danni",
      "Sostituzione serrature e cilindri",
      "Apertura rapida, anche di notte",
    ],
  },
  {
    id: "automazioni",
    name: "Automazioni & Cancelli",
    tag: "Automazioni",
    icon: "cog",
    img: GATE_IMG,
    alt: "Cancello elettrico automatizzato",
    eta: "30-45 min",
    bullets: [
      "Ricerca guasti su cancelli elettrici",
      "Sostituzione componenti e motori",
      "Manutenzione programmata e straordinaria",
    ],
  },
];

export const ZONES = [
  {
    name: "Roma Centro",
    areas: ["Prati", "Trastevere", "Parioli", "Monti", "Centro Storico", "Esquilino", "Campo de' Fiori"],
  },
  {
    name: "Roma Nord",
    areas: ["Flaminio", "Cassia", "Salario", "Montesacro", "Fidene", "Val Melaina", "Prima Porta"],
  },
  {
    name: "Roma Sud",
    areas: ["EUR", "Garbatella", "Ostiense", "Laurentina", "Ardeatino", "Montagnola"],
  },
  {
    name: "Roma Est",
    areas: ["Tiburtina", "Centocelle", "Prenestino", "Collatino", "Alessandrino", "Tor Sapienza"],
  },
  {
    name: "Roma Ovest",
    areas: ["Aurelio", "Monteverde", "Boccea", "Balduina", "Primavalle", "Cornelia"],
  },
  {
    name: "Ostia e Litorale",
    areas: ["Ostia", "Acilia", "Fiumicino", "Ostia Antica", "Torvaianica", "Infernetto"],
  },
  {
    name: "Castelli Romani e Provincia",
    areas: ["Frascati", "Grottaferrata", "Marino", "Albano", "Velletri", "Tivoli", "Guidonia", "Monterotondo", "Ciampino", "Pomezia"],
  },
];
